import React from "react";
import "./BottomTabBar.css";

const tabs = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" />
      </svg>
    ),
  },
  {
    id: "cameras",
    label: "Cameras",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M2 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z" />
        <path d="M18 9l4-2v6l-4-2" />
        <rect x="2" y="16" width="16" height="4" rx="1" />
      </svg>
    ),
  },
  {
    id: "alerts",
    label: "Alerts",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 2a7 7 0 0 0-7 7c0 2.38-1.19 4.47-3 5.74V17h20v-2.26C20.19 13.47 19 11.38 19 9a7 7 0 0 0-7-7z" />
        <path d="M9 20a3 3 0 0 0 6 0" />
      </svg>
    ),
  },
  {
    id: "settings",
    label: "Settings",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
];

const BottomTabBar = ({ activeTab, onTabChange, recentCount = 0, systemStatus = 'Status available on dashboard' }) => {
  return (
    <nav className="bottom-tab-bar">
      <div className="desktop-brand"><strong>Raspberry Pi Server</strong><small>Home hub</small></div>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`bottom-tab ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="bottom-tab-icon">{tab.icon}</span>
          <span className="bottom-tab-label">{tab.label}</span>
          {tab.id === 'alerts' && recentCount > 0 && <span className="desktop-alert-count" title="Recent events">{recentCount}</span>}
        </button>
      ))}
      <div className="desktop-system-status"><strong>System status</strong><small>{systemStatus}</small></div>
    </nav>
  );
};

export default BottomTabBar;
